import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Modal, ModalBody } from "reactstrap";

class MinPriceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: "",
    };
  }

  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.minPriceModal}
          toggle={() => this.props.changeModal(!this.props.minPriceModal)}
        >
          <ModalBody className="row mx-0 p-4" style={{ flex: "unset" }}>
            <div className="col-12 px-0 fw-bold fs-5 mb-3">
              شرایط ارسال رایگان
            </div>
            <div className="col-12 px-0 fw-bold fs-5">
              <p className="text-secondary fw-bold fs-6">
                اگر مبلغ سفارش بیشتر از
              </p>
            </div>
            <div className="col-12 px-0 position-relative mb-3">
              <NumberFormat
                dir={this.state.price ? "ltr" : "trl"}
                thousandSeparator
                value={this.state.price}
                onBlur={(e) =>
                  e.target.value.replace(/,/gi, "") < 1000
                    ? e.target.classList.add("text-danger")
                    : e.target.classList.remove("text-danger")
                }
                onValueChange={(values) => {
                  this.setState({ price: values.value });
                }}
                className="form-control p-3 rounded14"
                placeholder="مثلا: 50,000 (تومان)"
              />
              {this.state.price && (
                <span
                  className="position-absolute fs-7 color-main bg-white px-2"
                  style={{ top: "-8px", right: "20px" }}
                >
                  مثلا: 50,000 (تومان)
                </span>
              )}
            </div>
            <div className="col-4 px-1 fw-bold fs-5">
              <button
                onClick={() => this.setState({ price: 100000 })}
                className="btn py-1 w-100 fw-bold rounded28 border-main-1 color-main fs-7"
              >
                100,000 تومان
              </button>
            </div>
            <div className="col-4 px-1 fw-bold fs-5">
              <button
                onClick={() => this.setState({ price: 200000 })}
                className="btn py-1 w-100 fw-bold rounded28 border-main-1 color-main fs-7"
              >
                200,000 تومان
              </button>
            </div>
            <div className="col-4 px-1 fw-bold fs-5">
              <button
                onClick={() => this.setState({ price: 500000 })}
                className="btn py-1 w-100 fw-bold rounded28 border-main-1 color-main fs-7"
              >
                500,000 تومان
              </button>
            </div>
            <div className="col-12 px-0 fw-bold mt-3">
              <p className="text-secondary fw-bold fs-6">
                باشد، ارسال رایگان شود
              </p>
            </div>
            <div className="col-12 px-0 fw-bold fs-5 mt-4">
              <button
                disabled={this.state.price < 1000}
                onClick={() => {
                  this.props.setPrice(this.state.price);
                  this.props.changeModal(false);
                }}
                className="btn px-3 py-2-3 bg-disabled w-100 bg-color-main fw-bold rounded28 text-white"
              >
                ثبت
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default MinPriceModal;
